import {Component, Inject, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';
import {DrivingSchoolService} from '../../driving-school.service';
import {AlertService} from 'ngx-alerts';

@Component({
  selector: 'app-driving-school-commission-earnings',
  templateUrl: './driving-school-commission-earnings.component.html',
  styleUrls: ['./driving-school-commission-earnings.component.scss']
})
export class DrivingSchoolCommissionEarningsComponent implements OnInit {

  user: any;
  search = {
    page: 0,
    size: 20
  };
  totalRecords = 0;
  pageEvent: PageEvent;

  userReferrals: any[] = [];

  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService, private drivingSchoolService: DrivingSchoolService,
              private alertService: AlertService) {
    this.user = this.storage.get('gs-loggedInUserData');
  }

  ngOnInit(): void {
    this.getUserOrderCommissions();
  }

  private getUserOrderCommissions() {
    this.drivingSchoolService.getUserOrderCommissions(this.user.userId).subscribe(
      (res: any) => {
        this.userReferrals = res.orderCommissions;
        this.totalRecords = res.totalRecords;
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  getServerData(ev: PageEvent) {
    this.search.page = ev.pageIndex;
    this.search.size = ev.pageSize;
    this.getUserOrderCommissions();
    return ev;
  }

}
